<template>
  <div id="contact" class="page modal">
    <div class="inner">
      <section>
        <h3>CONTACT<span>お問い合わせ</span></h3>
        <p>
          <label for="name">YOUR NAME<span>お名前</span></label>
          <input
              type="text"
              name="name"
              value=""
              v-model="name"
              v-validate="'required'"
              placeholder="お名前を入力してください"
              :class="{'has-error': errors.has('name')}">
          <span class="error" v-if="errors.has('name')">{{errors.first('name')}}</span>

          <label for="email">YOUR EMAIL<span>メールアドレス</span></label>
          <input
              type="email"
              name="email"
              value=""
              v-model="email"
              v-validate="'required|email'"
              placeholder="メールアドレスを入力してください"
              :class="{'has-error': errors.has('email')}">
          <span class="error" v-if="errors.has('email')">{{errors.first('email')}}</span>

          <label for="message">MESSAGE<span>お問い合わせ内容</span></label>
          <textarea
              name="message"
              rows="8" cols="80"
              v-model="message"
              v-validate="'required'"
              placeholder="お問い合わせ内容を詳細にご記入ください"
              :class="{'has-error': errors.has('message')}"></textarea>
          <span class="error" v-if="errors.has('message')">{{errors.first('message')}}</span>
          <button v-bind:disabled="sended" @click="register">Send<span>送信</span></button>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate)

let iframe = document.createElement('iframe');

function ready(){
  iframe.name = 'sendDataTarget';
  iframe.style.display = 'none';
  document.body.appendChild(iframe);
};
if (document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
  ready();
} else {
  document.addEventListener('DOMContentLoaded', ready);
}

function sendContact(name, email, message) {
  const postUrl = 'https://maker.ifttt.com/trigger/fci_jp_contact_send/with/key/daySYZ6j4UWePr4hmUXF4q';
  const data = {
    value1: name,
    value2: email,
    value3: message.replace(/\r\n/g, '<br>').replace(/(\n|\r)/g, '<br>'),
  };
  const info = 'お問い合わせありがとうございました。\n' +
      '数日のうちにご入力いただきましたメールアドレスに返信いたします。';
  postData(postUrl, data, info);
}

function postData(url, data, completeMessage) {

  const form = document.createElement('form');
  form.action = url;
  form.target = iframe.name;    // 送信ターゲットをiframeにする
  form.method = 'post';
  form.style.display = 'none';

  const inputNode = document.createElement('input');
  for(var name in data) {
    inputNode.name  = name;
    inputNode.value = data[name];
    form.appendChild(inputNode.cloneNode());
  }

  iframe.addEventListener('load', function () {
    console.log(completeMessage);
    alert(completeMessage);
  });
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

export default {
  name: 'Contact',
  data() {
    return {
      name: '',
      email: '',
      message: '',
      sended: false
    }
  },
  methods: {
    register (ev) {
      ev.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (!result) {
          console.log(this.errors.all())
          return false
        }
        sendContact(this.name, this.email, this.message)
        this.sended = true
        return false
      })
    }
  }
}
</script>

<style scoped lang="scss">
#contact {
  height: 100vh;
  width: 100vw;
  background: linear-gradient(to left, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 75%, rgba(255,255,255,0) 100%);
  color: #232323;
  padding: 10vh 20vw;
  text-align: center;
  overflow: hidden;

  .inner {
    overflow: auto;
    width: 100%;
    height: 100%;
  }

  input[type='text'],
  input[type='search'],
  input[type='tel'],
  input[type='url'],
  input[type='email'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='week'],
  input[type='time'],
  input[type='number'],
  input[type='file'],
  input[type='submit'],
  input[type='reset'],
  input[type='button'],
  input[type='image'],
  button,
  textarea,
  select {
    -webkit-appearance: none;
    box-sizing: border-box;
    font-size: 1rem;
    vertical-align: top;
    padding: 0.5rem;

  }

  input[type='text'],
  input[type='search'],
  input[type='tel'],
  input[type='url'],
  input[type='email'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='week'],
  input[type='time'],
  input[type='number'],
  input[type='file'],
  textarea,
  select {
    width: 100%;
  }

  input[type='submit'],
  input[type='reset'],
  input[type='button'],
  button {
    height: auto;
  }

  input[type='image'] {
    max-width: 100%;
  }

  textarea {
    height: 10em;
    min-height: 2em;
    resize: vertical;
  }

  input[type='text'],
  input[type='search'],
  input[type='tel'],
  input[type='url'],
  input[type='email'],
  input[type='password'],
  input[type='datetime'],
  input[type='datetime-local'],
  input[type='date'],
  input[type='month'],
  input[type='week'],
  input[type='time'],
  input[type='number'],
  textarea,
  select {
    background: #fff;
    border: solid 1px #000;
    border-radius: 8px;
    &.has-error {
      border: solid 1px #ED1C24;
    }
  }

  input[type='submit'],
  input[type='reset'],
  input[type='button'],
  button {
    cursor: pointer;
    font-size: 0.75rem;
    background: rgba(0,0,0,0.8);
    border: 2px solid rgba(0,0,0,0.8);
    border-radius: 8px;
    color: #fff;
    width: 100%;
    span {
      display: block;
      font-size: 0.25rem;
    }
    &:disabled {
      background: rgba(0,0,0,0.1);
      color: rgba(0,0,0,0.5);
    }
  }

  label {
    display: block;
    font-size: 0.75rem;
    padding-top: 0.5rem;

    span {
      display: block;
      font-size: 0.5rem;
    }
  }
  span.error {
    display: block;
    font-size: 0.5rem;
    text-align: right;
    color: #ED1C24;
  }

  h2, h3 {
    font-family: 'Roboto', sans-serif;
    font-weight: 100;
  }

  h2 {
    color: #232323;
  }

  section {
    padding: 2rem 0;

    h3 {
      color: #232323;
      font-size: 1.5rem;
      position: relative;
      padding: .5rem 0;

      &:after {
        content: "";
        position: absolute;
        left: calc(50% - 75px);
        bottom: 0;
        width: 150px;
        height: 4px;
        background: repeating-linear-gradient(-45deg, #ED1C24, #ED1C24 2px, transparent 2px, transparent 4px);
      }

      span {
        display: block;
        font-size: 0.75rem;
        padding-top: 0.25rem;
      }
    }

    p {
      padding: .5rem;
      letter-spacing: 0.1rem;
      width: 600px;
      max-width: 100%;
      margin: 0 auto;
      text-align: left;
    }

    ul {
      list-style: none;
      padding-top: 1rem;

      li {
        font-size: 0.75rem;

        span {
          display: inline-block;
        }

        .date {
          width: 100px;
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue